/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { UTC, DateRange }                        from 'rewire-common';
import {
  IEmployeeSummary,
  IEmployeeTimecardStatus,
  ITimecard,
  SaveTimecardInput,
}                                                from '../../DataTypes';
import DataMutations                             from '../../graphql/Mutations';
import {
  DailyRollupModelBase,
  IRolledUpTimecard,
}                                                from '../../timecard//DailyRollupModel';
import {
  DailyTimecardModelBase,
}                                                from '../../timecard//DailyTimecardModel';
import {
  OtherPaymentsModelBase
}                                                from '../../timecard/OtherPaymentsModel';
import { TimecardModelBase }                     from '../../timecard/TimecardModel';
import timecardTestEditTimecardsDailyRollupModel from './TimecardTestEditTimecardsDailyRollupModel';
import TimecardTestEditTimecardsRolledUpTimecard from './TimecardTestEditTimecardsRolledUpTimecard';
import timecardTestDailyTimecardModel            from './TimecardTestDailyTimecardModel';
import timecardTestOtherPaymentsModel            from './TimecardTestOtherPaymentsModel';
import timecardTestListModel                     from '../TimecardTestListModel';
import { timecardTestRouteManager }              from '../../main-navigation/RouteManager';
import mainPageModel                             from '../../main-navigation/MainPageModel';

export class TimecardTestEditTimecardsModel extends TimecardModelBase {
  constructor() {
    super({canSubscribeToMessages: false});
  }

  async load() {
    const { filters } = timecardTestRouteManager;
    super.load(undefined, filters);
  }

  get rollupModel(): DailyRollupModelBase {
    return timecardTestEditTimecardsDailyRollupModel;
  }

  get dailyTimecardModel(): DailyTimecardModelBase {
    return timecardTestDailyTimecardModel;
  }

  get otherPaymentsModel(): OtherPaymentsModelBase {
    return timecardTestOtherPaymentsModel;
  }

  get effective(): DateRange | undefined {
    return timecardTestListModel.selectedTest?.effective;
  }

  get employees(): IEmployeeSummary[] {
    return timecardTestListModel.tests.map(t => ({
      id:         t.employee.id,
      name:       t.employee.name,
      warning:    0,
      error:      0,
      info:       0,
      isSelected: t.id === timecardTestListModel.selectedTest?.id,
      saving:     false,
    }));
  }

  get selectedEmployee(): IEmployeeSummary | undefined {
    const selectedEmployee = timecardTestListModel.selectedTest?.employee;
    if (!selectedEmployee) {
      return undefined;
    }
    return ({
      id:         selectedEmployee.id,
      name:       selectedEmployee.name,
      warning:    0,
      error:      0,
      info:       0,
      isSelected: true,
      saving:     false,
    });
  }

  get viewOnly(): boolean {
    return mainPageModel.testViewOnly;
  }

  async runRulesMutation(employeeId: string, effective: DateRange): Promise<boolean> {
    const result = await DataMutations.runTestTimecardRules(employeeId, effective);
    return !!result;
  }

  async saveMutation(timecards: SaveTimecardInput[]): Promise<boolean> {
    const result = await DataMutations.saveTestEmployeeTimecards(timecards);
    return !!result;
  }

  createRollup(earnedDate: UTC, timecards: ITimecard[], status: IEmployeeTimecardStatus | null): IRolledUpTimecard {
    return TimecardTestEditTimecardsRolledUpTimecard.create(earnedDate, timecards, status);
  }

  isNotInBatch(_earnedDate: UTC): boolean {
    return true;
  }

  async save(): Promise<boolean> {
    const saved = await super.save();
    if (saved) {
      await timecardTestListModel.runSelectedTest();
      return true;
    }
    return false;
  }

}

const timecardTestEditTimecardsModel = new TimecardTestEditTimecardsModel();
export default timecardTestEditTimecardsModel;